import { FeedSelectedList } from "@/pages/Private/redux/feed/feed.slice";

/**
 * Parses the RTS-style `listIds` URL param (`[{"id":12,"title":"…"}]`).
 * Malformed JSON, non-arrays and entries without a positive numeric id are
 * dropped so an invalid deep link falls back to the default selection.
 */
export const parseFeedListIdsParam = (raw: string | null): FeedSelectedList[] => {
	if (!raw) {
		return [];
	}

	try {
		const parsed: unknown = JSON.parse(raw);

		if (!Array.isArray(parsed)) {
			return [];
		}

		return parsed
			.map((entry: { id?: unknown; title?: unknown }) => ({
				id: Number(entry?.id),
				title: typeof entry?.title === "string" ? entry.title : "",
			}))
			.filter((entry) => Number.isInteger(entry.id) && entry.id > 0);
	} catch {
		return [];
	}
};

/** Parses the `page` URL param; anything but a positive integer is treated as absent. */
export const parseFeedPageParam = (raw: string | null): number | undefined => {
	if (!raw) {
		return undefined;
	}

	const page = Number(raw);

	return Number.isInteger(page) && page >= 1 ? page : undefined;
};
